import React from 'react';
import StateGamesPage from '../features/games/details/pages/StateGamesPage';

const StateGames: React.FC = () => <StateGamesPage />;

export default StateGames;
